import * as Yup from 'yup';

export const responseYupValidation = () => {
  return Yup.object().shape({
    company: Yup.string().required('required'),
    email: Yup.string().required('required').email('incorrectEmail'),
    market: Yup.string().required('required'),
    respondentVolume: Yup.string().required('required'),
    surveyTemplate: Yup.string().nullable(),
    gender: Yup.string().nullable(),
    ageFrom: Yup.string().nullable(),
    ageTo: Yup.string().nullable(),
    regionsCities: Yup.string().nullable(),
    otherRequirements: Yup.string().nullable(),
  });
};
